var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.blok.title)?_c('p',{staticClass:"storyblok-navigation-title"},[_vm._v(_vm._s(_vm.blok.title))]):_vm._e(),(_vm.blok)?_c('storyblok',{staticClass:"storyblok-navigation",attrs:{"blok":_vm.blok}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }